import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postChargeApprovalTracking({ body }) {
  return BaseService.post(REST.CHARGE_APPROVAL_TRACKING, body);
}

function putChargeApprovalTracking({ body, id }) {
  return BaseService.put(REST.CHARGE_APPROVAL_TRACKING_ID(id), body);
}

function getChargeApprovalTracking(params) {
  return BaseService.get(REST.CHARGE_APPROVAL_TRACKING, {
    params: paramsFilter({ params }),
  });
}

function deleteChargeApprovalTracking({ id }) {
  return BaseService.delete(REST.CHARGE_APPROVAL_TRACKING_ID(id));
}

export default {
  postChargeApprovalTracking,
  putChargeApprovalTracking,
  getChargeApprovalTracking,
  deleteChargeApprovalTracking,
};
